<template>
  <div
    v-if="!accepted"
    :class="{ justaccepted }"
  >
    <h1>
      <span>/</span> {{ $vuetify.lang.t("$vuetify.cookiePolicy.headline") }}
    </h1>
    <p>
      {{ $vuetify.lang.t("$vuetify.cookiePolicy.text") }}
      <a :href="$vuetify.lang.t('$vuetify.cookiePolicy.datenschutz.href')">{{
        $vuetify.lang.t("$vuetify.cookiePolicy.datenschutz.text")
      }}</a>
    </p>
    <p>
      <button @click="rememberAcceptance">
        {{ $vuetify.lang.t("$vuetify.cookiePolicy.button") }}
      </button>
    </p>
  </div>
</template>

<script>
import { LOCAL_STORAGE_WRAPPER } from '../StorageWrapper'

export default {
  name: 'CookiePolicy',
  data () {
    return {
      accepted: LOCAL_STORAGE_WRAPPER.getItem('cookie-policy') === 'accepted',
      justaccepted: false
    }
  },
  methods: {
    rememberAcceptance () {
      LOCAL_STORAGE_WRAPPER.setItem('cookie-policy', 'accepted')
      this.justaccepted = true
      window.setTimeout(() => (this.accepted = true), 3000)
    }
  }
}
</script>

<style scoped lang="scss">
$primary: #014b76;
$secondary: white;

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-500px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOutTop {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-500px);
  }
}

div {
  animation-name: fadeInDown;
  animation-duration: 2s;
  animation-fill-mode: both;
  transition: all 2s;
  padding: 3em 0 2em 0;
  text-align: center;
  left: 0;
  width: 100%;
  background: $primary;
  position: fixed;
  color: $secondary;
  z-index: 999999 !important;

  &.justaccepted {
    animation-name: fadeOutTop;
  }

  h1 span {
    font-size: 150%;
  }

  a {
    color: $secondary;
  }

  button {
    background: $secondary;
    color: $primary;
    padding: 0.5em 1em;
  }
}
</style>
